import {isTabletByScreen} from 'core/helpers/screen';
import {useResize} from 'core/hooks/useResize';
import {useCallback, useState} from 'react';

export const useIsTabletByScreen = () => {
    const [isTablet, setIsTablet] = useState<boolean>(isTabletByScreen());
    const handleWindowResize = useCallback(() => {
        setIsTablet(isTabletByScreen());
    }, []);

    useResize(handleWindowResize);

    return isTablet;
};
